import React from 'react'
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import KITCHEN_PNG from "../../global/assets/png/Kitchen-FirstTimeChecker.png"
import LoginForm from '../../composed/loginflow/LoginForm'
import './ResetPassword.scss'
import ResetPasswordForm from '../../composed/loginflow/ResetPasswordForm'
import Transition from './../../transition';

const ResetPassword = () => {

    if (isIpad || isMobile) {

        return (
            <ResetPasswordForm />
        )
    }


    return (
        <div className='resetpassword-desktop-container'>

            <div className='section-1-resetpassword-desktop'>

                {/* <img style={{ width: '100%', }} src={KITCHEN_PNG}></img> */}

            </div>
            <div className='section-2-resetpassword-desktop'> <ResetPasswordForm /> </div>

        </div>
    )
}

export default Transition(ResetPassword)